var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7861 8.84565H20.9V8.8H11V13.2H17.2167C16.3097 15.7614 13.8727 17.6 11 17.6C7.35515 17.6 4.4 14.6448 4.4 11C4.4 7.35515 7.35515 4.4 11 4.4C12.6825 4.4 14.2131 5.0347 15.3786 6.07145L18.4899 2.9601C16.5253 1.12915 13.8974 0 11 0C4.92525 0 0 4.92525 0 11C0 17.0748 4.92525 22 11 22C17.0748 22 22 17.0748 22 11C22 10.2625 21.9241 9.5425 21.7861 8.84565Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26831 5.88005L4.88236 8.5305C5.86026 6.1094 8.22856 4.4 11 4.4C12.6825 4.4 14.2131 5.0347 15.3786 6.07145L18.4899 2.9601C16.5253 1.12915 13.8974 0 11 0C6.77491 0 3.11081 2.38535 1.26831 5.88005Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C13.8413 22 16.423 20.9127 18.375 19.1444L14.9705 16.2635C13.829 17.1316 12.4341 17.6012 11 17.6C8.13893 17.6 5.70957 15.7757 4.79437 13.2297L1.20728 15.9935C3.02778 19.5558 6.72487 22 11 22Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.786 8.84558H20.9V8.79993H11V13.1999H17.2167C16.7828 14.419 16.0013 15.4842 14.9688 16.264L14.9704 16.2629L18.375 19.1438C18.1341 19.3627 22 16.4999 22 10.9999C22 10.2624 21.9241 9.54243 21.786 8.84558Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.69d74eaac73652b118c00fa7982e381d.svg";
export { ForwardRef as ReactComponent };